import React, { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { ToolCard } from "@/components/ToolCard";
import { PageHero } from "@/components/PageHero";
import { api } from "@/lib/api";

export default function AgentsPage() {
  const [agents, setAgents] = useState(null);
  useEffect(() => { api.get("/agents").then(r => setAgents(r.data)); }, []);
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="agents-header"
        eyebrow="AI Agents"
        badge="Capability Matrix"
        title={<>Autonomous, capable, <span className="italic">deployable.</span></>}
        sub="Catalog of every notable AI agent — coding agents, research agents, computer-use agents — with the same scoring rigor as our tool directory, plus a capability matrix."
      />

      {!agents ? <div className="grid grid-cols-2 gap-4">{[...Array(4)].map((_,i)=><div key={i} className="skeleton h-72"/>)}</div> :
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 stagger">
          {agents.map(a => <ToolCard key={a.slug} tool={a}/>)}
        </div>
      }

      {agents && agents.length > 0 && (
        <section className="mt-10 curio-card p-6" data-testid="capability-matrix-table">
          <h2 className="font-display text-2xl font-semibold mb-4">Capability matrix</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] uppercase tracking-widest text-[#5B6478]">
                  <th className="py-2">Agent</th><th>Browse</th><th>Code</th><th>Tools</th><th>Autonomous</th><th>Integrations</th>
                </tr>
              </thead>
              <tbody>
                {agents.map(a=>(
                  <tr key={a.slug} className="border-t border-[#E3E8F0]">
                    <td className="py-3 font-medium">{a.name}</td>
                    {["browse","code","tools","autonomous","integrations"].map(k=>(
                      <td key={k}>{a.capabilities?.[k] ? "✓" : "—"}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </Layout>
  );
}
